import React, { useEffect, useState } from 'react';
import { Modal, Input, notification } from 'antd';
import axios from 'axios';

const TutorProfileEdit = ({ trainer, open, onClose, onSaved }) => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [vimeo, setVimeo] = useState('');
  const [email, setEmail] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open && trainer) {
      setFirstName(trainer.first_name || '');
      setLastName(trainer.last_name || '');
      setVimeo(trainer.vimeo != null ? String(trainer.vimeo) : '');
      setEmail(trainer.email || '');
    }
  }, [open, trainer]);

  const handleSave = async () => {
    if (!trainer?.id) return;

    const trimmedFirst = firstName.trim();
    const trimmedLast = lastName.trim();
    const trimmedVimeo = vimeo.trim();
    const trimmedEmail = email.trim();

    if (!trimmedFirst || !trimmedLast || !trimmedVimeo || !trimmedEmail) {
      notification.error({ message: 'Tüm alanlar zorunludur.' });
      return;
    }

    setSaving(true);
    try {
      await axios.post(`trainer/profile/${trainer.id}`, {
        first_name: trimmedFirst,
        last_name: trimmedLast,
        vimeo: trimmedVimeo,
        email: trimmedEmail,
      });
      notification.success({ message: 'Profil güncellendi' });
      onSaved?.();
      onClose();
    } catch (err) {
      const msg = err?.response?.data?.message || 'Kaydetme başarısız';
      notification.error({ message: msg });
    } finally {
      setSaving(false);
    }
  };

  const title = trainer
    ? `${trainer.first_name} ${trainer.last_name} — Profil Düzenle`
    : 'Profil Düzenle';

  return (
    <Modal
      title={title}
      open={open}
      onOk={handleSave}
      onCancel={onClose}
      confirmLoading={saving}
      okText="Kaydet"
      cancelText="İptal"
      width={480}
      destroyOnClose
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <div>
          <label style={{ display: 'block', marginBottom: 6, fontWeight: 500 }}>Ad</label>
          <Input
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            placeholder="Ad"
          />
        </div>
        <div>
          <label style={{ display: 'block', marginBottom: 6, fontWeight: 500 }}>Soyad</label>
          <Input
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            placeholder="Soyad"
          />
        </div>
        <div>
          <label style={{ display: 'block', marginBottom: 6, fontWeight: 500 }}>Vimeo</label>
          <Input
            value={vimeo}
            onChange={(e) => setVimeo(e.target.value)}
            placeholder="Vimeo ID"
          />
        </div>
        <div>
          <label style={{ display: 'block', marginBottom: 6, fontWeight: 500 }}>E-posta</label>
          <Input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="E-posta adresi"
          />
        </div>
      </div>
    </Modal>
  );
};

export default TutorProfileEdit;
